import { useEffect, useState } from 'react';
import { getProjectConfig, updateProjectConfig } from '../../api/constlink';
import ProjectTypeListComponent from '../../components/enterprises/ProjectTypeListComponent';
import ProjectTypeAddModal from '../../components/enterprises/ProjectTypeAddModal';

interface ProjectConfigContainerProps {
  enterpriseId: string;
}

function ProjectConfigContainer({ enterpriseId }: ProjectConfigContainerProps) {
  const [visibleProjectTypeAddModal, setVisibleProjectTypeAddModal] =
    useState(false);
  const [projectConfig, setProjectConfig] = useState<any>();

  useEffect(() => {
    (async () => {
      const _projectConfig = await getProjectConfig({ enterpriseId });
      setProjectConfig(_projectConfig);
    })();
  }, [enterpriseId]);

  const onDeleteProjectType = async (name: string) => {
    const filteredTypes = projectConfig.types.filter(
      (type: any) => type.name !== name,
    );
    const resProjectConfig = await updateProjectConfig({
      enterpriseId,
      data: { ...projectConfig, types: filteredTypes },
    });
    setProjectConfig(resProjectConfig);
  };

  const onCreateProjectType = async (type: any) => {
    const _types = [...projectConfig.types];
    _types.push(type);
    const resProjectConfig = await updateProjectConfig({
      enterpriseId,
      data: { ...projectConfig, types: _types },
    });
    setProjectConfig(resProjectConfig);
    setVisibleProjectTypeAddModal(false);
  };

  const closeProjectTypeAddModal = () => {
    setVisibleProjectTypeAddModal(false);
  };

  const openProjectTypeAddModal = () => setVisibleProjectTypeAddModal(true);

  return (
    <>
      {projectConfig && (
        <ProjectTypeListComponent
          types={projectConfig.types}
          onDelete={onDeleteProjectType}
          openProjectTypeAddModal={openProjectTypeAddModal}
        />
      )}

      {visibleProjectTypeAddModal && projectConfig && (
        <ProjectTypeAddModal
          visible={visibleProjectTypeAddModal}
          types={projectConfig.types}
          onCreate={onCreateProjectType}
          onCancel={closeProjectTypeAddModal}
        />
      )}
    </>
  );
}

export default ProjectConfigContainer;
